export const moduleSlug = "ROLES";

export default { moduleSlug };